export default __webpack_public_path__ + "static/media/email-supportTD.df396148.svg";